import { render, staticRenderFns } from "./BrowsePagination.vue?vue&type=template&id=73a61bf4&scoped=true&"
import script from "./BrowsePagination.vue?vue&type=script&lang=ts&"
export * from "./BrowsePagination.vue?vue&type=script&lang=ts&"
import style0 from "./BrowsePagination.vue?vue&type=style&index=0&id=73a61bf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a61bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a61bf4')) {
      api.createRecord('73a61bf4', component.options)
    } else {
      api.reload('73a61bf4', component.options)
    }
    module.hot.accept("./BrowsePagination.vue?vue&type=template&id=73a61bf4&scoped=true&", function () {
      api.rerender('73a61bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BrowsePagination.vue"
export default component.exports